module.exports = __webpack_public_path__ + "img/Leo.2e40a729.png";